import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  border: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  background-color: unset;\n  cursor: pointer;\n  transition: color 0.1s ease-out, transform 0.1s ease-out;\n  color: ", ";\n  &:hover,\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED } from '../../colors';
import { appearanceNoneStyle } from '../../tokens/appearance';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
export var baseLinkStyle = css(_templateObject(), baseSelectionStyle, baseHighlightStyle, appearanceNoneStyle, ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED);